export const RAGE_CLICK = 'rageClick';

export const ERROR_CLICK = 'errorClicks';

export const DEAD_CLICK = 'deadClicks';

export const TRENDING_DOWN = 'trendingDown';

export const TRENDING_UP = 'trendingUp';

export const FIRST_TIME_USE = 'firstTimeUse';

export const RELEVANCE = 'relevance';

export const INSIGHT_CATEGORIES = {
    TRENDING_UP,
    TRENDING_DOWN,
    RAGE_CLICK,
    ERROR_CLICK,
    DEAD_CLICK,
    FIRST_TIME_USE,
    RELEVANCE,
};

export const FRUSTRATION_INSIGHT_TYPES = [RAGE_CLICK, ERROR_CLICK, DEAD_CLICK];

export const DATE_DEPENDENT_INSIGHT_TYPES = [RAGE_CLICK, ERROR_CLICK, DEAD_CLICK, FIRST_TIME_USE];

export const INSIGHT_CARD_ICONS = {
    [TRENDING_UP]: 'trending-up',
    [TRENDING_DOWN]: 'trending-down',
    [RAGE_CLICK]: 'angry',
    [ERROR_CLICK]: 'alert-triangle',
    [DEAD_CLICK]: 'skull',
    [FIRST_TIME_USE]: 'user-plus',
};

export const INSIGHT_CARD_TYPES = {
    PLAYER: 'player',
    LIBRARY: 'library',
};

export const PAGE = 'Page';

export const FEATURE = 'Feature';

export const GUIDE = 'Guide';

export const UNSUPPORTED_INSIGHT_FILTERS = {
    [TRENDING_UP]: ['guide', 'date'],
    [TRENDING_DOWN]: ['guide', 'date'],
    [RAGE_CLICK]: ['guide'],
    [ERROR_CLICK]: ['guide'],
    [DEAD_CLICK]: ['guide'],
    [FIRST_TIME_USE]: [],
};

export const VALUE_ACTIONS = {
    COPY_LINK: 'copy link - full replay',
    COPY_LINK_CLIP: 'copy link - clip',
    SAVE_CLIP: 'save clip',
    ADD_TO_PLAYLIST: 'add to playlist',
    CREATE_ISSUE: 'create issue',
    CREATE_FUNNEL: 'create funnel',
    CREATE_DX: 'create dx report',
};
